import { PixInput, PixRadioButton } from '@1024pix/nebulix-ember';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { t } from 'ember-intl';
import { eq, not } from 'ember-truth-helpers';
import { ID_PIX_TYPES } from 'pix-orga/constants/id-pix-types';

import displayCampaignErrors from '../../../helpers/display-campaign-errors';
import ExplanationCard from '../../ui/explanation-card';
import FormField from '../../ui/form-field';
import PixFieldset from '../../ui/pix-fieldset';

export default class ExternalId extends Component {
  @tracked wantAdditionalIdentifier = Boolean(this.args.campaign.externalIdLabel);

  get isAdditionalIdentifierChecked() {
    return this.wantAdditionalIdentifier === true;
  }

  @action
  setAdditionalIdentifierSelected(value) {
    this.wantAdditionalIdentifier = value;
    this.args.campaign.externalIdLabel = null;
    this.args.campaign.externalIdType = null;
  }

  @action
  onChangeExternalIdType(event) {
    this.args.campaign.externalIdType = event.target.value;
  }

  @action
  onChangeExternalIdLabel(event) {
    this.args.campaign.externalIdLabel = event.target.value;
  }

  <template>
    <FormField>
      <:default>
        <PixFieldset aria-labelledby="external-ids-label" role="radiogroup">
          <:title>{{t "pages.campaign-creation.external-id-label.question-label"}}</:title>
          <:content>
            <PixRadioButton
              name="external-id-label"
              @value="false"
              {{on "change" (fn this.setAdditionalIdentifierSelected false)}}
              checked={{not this.isAdditionalIdentifierChecked}}
            >
              <:label>{{t "pages.campaign-creation.no"}}</:label>
            </PixRadioButton>
            <PixRadioButton
              name="external-id-label"
              @value="true"
              {{on "change" (fn this.setAdditionalIdentifierSelected true)}}
              checked={{this.isAdditionalIdentifierChecked}}
            >
              <:label>{{t "pages.campaign-creation.yes"}}</:label>
            </PixRadioButton>
          </:content>
        </PixFieldset>
      </:default>
      <:information>
        <ExplanationCard id="external-ids-label-info">
          <:title>{{t "pages.campaign-creation.external-id-label.information.label"}}</:title>

          <:message>{{t "pages.campaign-creation.external-id-label.information.message" htmlSafe=true}}</:message>
        </ExplanationCard>
      </:information>
    </FormField>

    {{#if this.isAdditionalIdentifierChecked}}
      <FormField>
        <:default>
          <PixFieldset @required={{true}} aria-labelledby="external-ids-types" role="radiogroup">
            <:title>{{t "pages.campaign-creation.external-id-type.question-label"}}</:title>
            <:content>
              <PixRadioButton
                name="external-id-types"
                @value="EMAIL"
                {{on "change" this.onChangeExternalIdType}}
                checked={{eq @campaign.externalIdType "EMAIL"}}
              >
                <:label>{{t ID_PIX_TYPES.EMAIL}}</:label>

              </PixRadioButton>
              <PixRadioButton
                name="external-id-types"
                @value="STRING"
                {{on "change" this.onChangeExternalIdType}}
                checked={{eq @campaign.externalIdType "STRING"}}
              >
                <:label>{{t ID_PIX_TYPES.STRING}}</:label>
              </PixRadioButton>
              {{#if @errors.externalIdType}}
                <div class="form__error error-message">
                  {{displayCampaignErrors @errors.externalIdType}}
                </div>
              {{/if}}
            </:content>
          </PixFieldset>
        </:default>
        <:information>
          <ExplanationCard id="external-ids-types-info">
            <:title>{{t "pages.campaign-creation.external-id-type.information.label"}}</:title>

            <:message>{{t "pages.campaign-creation.external-id-type.information.message" htmlSafe=true}}</:message>
          </ExplanationCard>
        </:information>
      </FormField>
      <FormField>
        <PixInput
          @id="external-id-label"
          @name="external-id-label"
          @subLabel={{t "pages.campaign-creation.external-id-label.suggestion"}}
          maxlength="255"
          @requiredLabel={{t "pages.campaign-creation.external-id-label.required"}}
          {{on "change" this.onChangeExternalIdLabel}}
          @value={{@campaign.externalIdLabel}}
        >
          <:label>{{t "pages.campaign-creation.external-id-label.label"}}</:label>
        </PixInput>

        {{#if @errors.externalIdLabel}}
          <div class="form__error error-message">
            {{displayCampaignErrors @errors.externalIdLabel}}
          </div>
        {{/if}}
      </FormField>

      <div class="gdpr-information-external-id">
        {{t "pages.campaign-creation.legal-warning"}}
      </div>
    {{/if}}
  </template>
}
